import {openDb} from "../../../Services/BrowserDatabaseIDB";
import {ensureStoresExist} from "../../../Services/BrowserDatabaseFunctions";

export function updateEventTimetable(_event_id, _updated_timetable) {
    return openDb("pa", 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction("Events", "readwrite");
            const dataStore = tx.objectStore("Events");

            // Get the specific event by its id
            return dataStore.get(_event_id).then(event => {
                if (!event) {
                    console.error(`❌ Event with ID ${_event_id} not found.`);
                    return false;
                }

                //set the event time_table
                event.time_table = _updated_timetable;

                const sanitizedEvent = JSON.parse(JSON.stringify(event));

                return dataStore.put(sanitizedEvent).then(() => {
                    console.log(
                        `✅ Timetable in Event ${_event_id} updated successfully.`
                    );
                    return true;
                });
            });
        })
        .catch(function (error) {
            console.error("❌ An error occurred while updating Event document:", error);
            throw error;
        });
}